<template>
  <div class="benefits-tier-rewards">
    <ul v-if="rewards.length" class="benefits-tier-rewards-grid">
      <li
        v-for="reward in rewards"
        :key="reward.id"
        class="benefits-tier-reward"
        :class="{ 'is-inactive': reward.active === false }"
      >
        <img v-if="reward.image && reward.image.url" class="benefits-tier-reward-image" :src="reward.image.url" alt="" />

        <span class="benefits-tier-reward-info">
          <strong :title="reward.name">{{ reward.name }}</strong>
          <span class="benefits-tier-reward-cost">
            {{ reward.points || 0 }} {{ t("benefitsCenter-points-pointsLabel") }}
          </span>
        </span>
      </li>
    </ul>

    <p v-else class="benefits-tier-rewards-empty">{{ t("benefitsCenter-tiers-panel-rewardsEmpty") }}</p>
  </div>
</template>

<script>
export default {
  name: "BenefitsTierRewardsGrid",
  props: {
    rewards: { type: Array, default: () => [] },
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
  },
};
</script>

<style lang="scss" scoped>
.benefits-tier-rewards-grid {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  list-style: none;
  margin: 0;
  padding: 0;
}

.benefits-tier-reward {
  align-items: center;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  display: flex;
  gap: 10px;
  min-width: 0;
  padding: 8px;

  &.is-inactive {
    opacity: 0.55;

    .benefits-tier-reward-image {
      filter: grayscale(1);
    }
  }
}

.benefits-tier-reward-image {
  border-radius: 8px;
  flex: 0 0 48px;
  height: 48px;
  object-fit: cover;
  width: 48px;
}

.benefits-tier-reward-info {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 2px;
  min-width: 0;

  strong {
    color: #384250;
    font-family: "Sora", sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.benefits-tier-reward-cost {
  color: #17b26a;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
}

.benefits-tier-rewards-empty {
  border: 1px dashed #d2d6db;
  border-radius: 12px;
  color: #6c737f;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  margin: 0;
  padding: 16px;
  text-align: center;
}

@media (max-width: 480px) {
  .benefits-tier-rewards-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
